// extracted by mini-css-extract-plugin
module.exports = {"card":"expertise-card_card__LJVik","card__svg":"expertise-card_card__svg__WFkDZ","card__info":"expertise-card_card__info__8p3R6","card__title":"expertise-card_card__title__MFH98"};